import { FiBell } from "react-icons/fi";
import { FaRegMoon } from "react-icons/fa";

import DataUpLogo from "../assets/images/DataUpLogoAuth.svg";
import { CountryIcon, Person } from "../assets/Icons";
import { useDarkMode } from "../context/DarkModeContext";
import { useAppSelector } from "../hooks/hooks";

const Navbar = () => {
  const { user } = useAppSelector((state) => state.auth);
  const { toggleDarkMode } = useDarkMode();
  return (
    <div className="bg-white dark:bg-BG-dark p-4 shadow-md">
      <div className="flex items-center justify-between mx-6">
        <div>
          <img
            src={DataUpLogo}
            alt="Package"
            className="w-full h-[40px] mx-auto mb-4"
          />
        </div>
        <div className="flex items-center gap-4">
          <div className="bg-[#F4F4F5] dark:bg-[#FFFFFF1A] p-2 lg:p-2 rounded-3xl">
            <CountryIcon />
          </div>
          <div
            className="bg-[#F4F4F5] dark:bg-[#FFFFFF1A] p-2 lg:p-2 rounded-3xl"
            onClick={toggleDarkMode}
          >
            <FaRegMoon size={24} className="dark:text-white" />
          </div>
          <div className="bg-[#F4F4F5] dark:bg-[#FFFFFF1A] flex items-center justify-center w-[40px] h-[40px] rounded-3xl">
            <FiBell className=" dark:text-white text-2xl" />
          </div>
          <div className="flex gap-2 text-[10px] bg-[#F4F4F5] dark:bg-[#FFFFFF1A] p-0  rounded-[24px] w-full h-[45px]">
            <div className="flex items-center gap-[12px] py-[10px] px-[14px]">
              <Person />
              <div>
                <p className="text-lg font-semibold dark:text-white">
                  {user?.firstname || "User"}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
